import classNames from 'classnames';
import React from 'react';

import Heading from '@jpp/atoms/Heading';
import { EIconType } from '@jpp/atoms/Icon/utils/types';
import SocialItem from '@jpp/atoms/SocialItem';
import Container from '@jpp/shared/Grid/Container';
import Flex from '@jpp/shared/Grid/Flex';
import Row from '@jpp/shared/Grid/Row';
import Section from '@jpp/shared/Grid/Section';
import { ETheme } from 'common/typings/enums';

import './ContactContent.scss';

export interface IContactContentProps {
  className?: string;
  theme?: Core.TTheme;
}

export interface IStoreContactContentProps {
  address: string;
  facebook: string;
  instagram: string;
  untappd: string;
  twitter: string;
  general_email: string;
  company_number: string;
  opening_times: Core.IOpeningTime[];
}

type TContactContent = IContactContentProps & IStoreContactContentProps;

const ROOT_CLASSNAME = 'ContactContent';

export const ContactContent: React.FunctionComponent<TContactContent> = ({
  theme,
  address,
  facebook,
  general_email,
  className,
  instagram,
  twitter,
  untappd,
  opening_times,
  company_number,
}) => {
  const defaultSocialItemProps = {
    theme: ETheme.Brand,
    className: `${ROOT_CLASSNAME}__social-item`,
  };

  const socialArray = [
    {
      url: instagram,
      icon: EIconType.Instagram,
    },
    {
      url: twitter,
      icon: EIconType.Twitter,
    },
    {
      url: facebook,
      icon: EIconType.Facebook,
    },
    {
      url: untappd,
      icon: EIconType.Untappd,
    },
  ];

  return (
    <Section className={classNames(ROOT_CLASSNAME, className)} theme={theme}>
      <Container>
        <Row>
          <Flex colLg={4} className={`${ROOT_CLASSNAME}__content-wrapper`}>
            <Heading priority={2} className={`${ROOT_CLASSNAME}__heading`}>
              Location
            </Heading>
            <address
              className={`${ROOT_CLASSNAME}__copy`}
              dangerouslySetInnerHTML={{ __html: address }}
            />
          </Flex>

          <Flex colLg={4} className={`${ROOT_CLASSNAME}__content-wrapper`}>
            <Heading priority={2} className={`${ROOT_CLASSNAME}__heading`}>
              Contact
            </Heading>
            <p className={`${ROOT_CLASSNAME}__copy`}>{company_number}</p>
            <p className={`${ROOT_CLASSNAME}__copy`}>{general_email}</p>

            {socialArray && (
              <ul className={`${ROOT_CLASSNAME}__social-list`}>
                {socialArray.map(({ url, icon }, index) => {
                  if (!url) {
                    return null;
                  }

                  return (
                    <SocialItem
                      {...defaultSocialItemProps}
                      key={index}
                      name={icon}
                      link={url}
                    >
                      {`@${url}`}
                    </SocialItem>
                  );
                })}
              </ul>
            )}
          </Flex>

          {opening_times && (
            <Flex colLg={4} className={`${ROOT_CLASSNAME}__content-wrapper`}>
              <Heading priority={2} className={`${ROOT_CLASSNAME}__heading`}>
                Brewery Opening Times
              </Heading>

              {opening_times.map((opening, index) => {
                const { day, closing_time, opening_time } = opening;

                return (
                  <p
                    key={`${day} ${index}`}
                    className={`${ROOT_CLASSNAME}__copy`}
                  >
                    {`${day}: ${opening_time}-${closing_time}`}
                  </p>
                );
              })}
            </Flex>
          )}
        </Row>
      </Container>
    </Section>
  );
};
